// 应用商城
export default [
	{
		path: '/mall',
		name: 'Mall',
		redirect: '/mall/index',
		component: () => import('@/views/mall/index'),
		meta: { title: '应用商城', whiteListed: false },
		children: [
			{
				path: 'shop/apply',
				name: 'MallShopApply',
				component: () => import('@/views/mall/shop/apply.vue'),
				meta: { title: '店铺申请' }
			},
			{
				path: 'shop/my',
				name: 'MallMyShop',
				component: () => import('@/views/mall/shop/my.vue'),
				meta: { title: '我的店铺' }
			},
			{
				path: 'shop/apply-detail',
				name: 'MallShopApplyDetail',
				component: () => import('@/views/mall/shop/applyDetail.vue'),
				meta: { title: '申请详情' }
			},
			{
				path: 'shop/change',
				name: 'MallShopChange',
				component: () => import('@/views/mall/shop/apply.vue'),
				meta: { title: '资料变更' }
			},
			{
				path: 'shop/close',
				name: 'MallShopClose',
				component: () => import('@/views/mall/shop/close.vue'),
				meta: { title: '闭店申请' }
			},
			{
				path: 'shop/goods-publish',
				name: 'MallGoodsPublish',
				component: () => import('@/views/mall/shop/goodsPublish.vue'),
				meta: { title: '发布商品' }
			},
			{
				path: 'shop/goods-manage',
				name: 'MallGoodsManage',
				component: () => import('@/views/mall/shop/goodsManage.vue'),
				meta: { title: '商品管理' }
			}
		]
	}
]
